const ConfigurationDomainValidator = (t) => {
  let regexs = {
    domainRegex: new RegExp(/^((?!@)([a-z0-9._-]+\.)+[a-z0-9_-]{1,})$/),
  }
  let validators = {
    domainValidator: (value) => {
      if (value.length > 0) {
        return (regexs.domainRegex.test(value) ? "" : t('configuration.administrate.textValidator.email'))
      }
    }
  }
  return validators
}

export { ConfigurationDomainValidator as default }
